var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0827 0.335938H1.91602C0.949517 0.335937 0.166016 1.11944 0.166016 2.08594V7.91927C0.166016 8.88577 0.949517 9.66927 1.91602 9.66927H10.0827C11.0492 9.66927 11.8327 8.88577 11.8327 7.91927V2.08594C11.8327 1.11944 11.0492 0.335937 10.0827 0.335938ZM9.84263 1.5L6.41263 4.93C6.3031 5.04043 6.154 5.10255 5.99846 5.10255C5.84293 5.10255 5.69383 5.04043 5.5843 4.93L2.1543 1.5H9.84263ZM10.6654 7.92229C10.6654 8.24446 10.4042 8.50562 10.082 8.50562H1.91536C1.5932 8.50562 1.33203 8.24446 1.33203 7.92229V2.32812L4.76203 5.75813C5.44527 6.44052 6.55212 6.44052 7.23536 5.75813L10.6654 2.32812V7.92229Z",
    fill: "#1B7EB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemail);
export default __webpack_public_path__ + "static/media/remail.dd9208df6f8f76883140d6c91833aada.svg";
export { ForwardRef as ReactComponent };